import { getValueByIdFromUrl } from 'utils/urlParser';
import { PWA, PWA_CLEAR } from './localstoreKeys';

export const REGISTRATION_UTM_MEDIUM = 'utm_medium';

export const REGISTRATION_UTM_SOURCE = 'utm_source';

export const REGISTRATION_UTM_CAMPAING = 'utm_campaign';

export const REGISTRATION_CLICK_ID_CAMPAING = 'clickid';

export const LANGUAGE_NAME_URL = getValueByIdFromUrl(
  'lang',
  window.location.href
);

export const MONTHLY_BONUS_AVAILABLE =
  getValueByIdFromUrl('monthly_bonus_activation', window.location.href) ===
  'dagdagdafsdfsfdsfs';

// TODO for retation send after signin
export const UTM_CONTENT = 'utm_content';

export const VALID_MOBILE_APP_PARAM = 'is_valid_mobile';

export const IS_VALID_MOBILE_APP = Boolean(
  getValueByIdFromUrl(VALID_MOBILE_APP_PARAM, window.location.href)
);

const ENCRYPT_KEY = 'sessionId';

export const ENCRYPT_DATA = getValueByIdFromUrl(
  ENCRYPT_KEY,
  window.location.href
);

export const IS_PWA = true; //Boolean(getValueByIdFromUrl(PWA, window.location.href));

export const IS_CLEAR_PWA = Boolean(
  getValueByIdFromUrl(PWA_CLEAR, window.location.href)
);

// DEBAGGING

export const INR_WITH_VPA =
  getValueByIdFromUrl('vpa', window.location.href) === '1';

// ======================== REGISTRATION ========================

// ======================== END ========================
